import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';

export class AffinityIceTrait extends Trait {
  static baseType = TraitType.AffinityIce;
  static baseTitle = 'Elemental Affinity (Ice)';
  static baseText = 'Immune to Freezing and Stunned.';
  static baseIcon = 'trait';

  type = AffinityIceTrait.baseType;
  title = AffinityIceTrait.baseTitle;
  text = AffinityIceTrait.baseText;
  icon = AffinityIceTrait.baseIcon;

  modifierAdd(type: StatusEffect, stacks: number) {
    if (type == StatusEffect.Freezing || type == StatusEffect.Stunned) {
      return 0;
    }
    return stacks;
  }
}

TraitRegistry.register(AffinityIceTrait.baseType, AffinityIceTrait);
